import {
  install as installGoogleMaps,
  Map,
  Marker,
  InfoWindow,
  Polyline,
  Circle,
  Autocomplete,
} from 'vue2-google-maps';

const GoogleMaps = {
  install(Vue, googleMapsKey) {
    if (!googleMapsKey) {
      throw new Error('Google Maps key is required');
    }

    installGoogleMaps(Vue, {
      installComponents: false,
      load: {
        libraries: 'places',
        key: googleMapsKey,
      },
    });

    Vue.component('GmapMap', Map);
    Vue.component('GmapMarker', Marker);
    Vue.component('GmapCircle', Circle);
    Vue.component('GmapPolyline', Polyline);
    Vue.component('GmapInfoWindow', InfoWindow);
    Vue.component('GmapAutocomplete', Autocomplete);
  },
  // Expose components for convenience
  Map,
  Marker,
  Circle,
  InfoWindow,
  Autocomplete,
};

export default GoogleMaps;
